<template>
  <div class="min-h-screen bg-gray-50">
    <div class="bg-white rounded-lg border-b border-gray-200">
      <div class="mx-auto py-3 px-2 ">
        <div class="flex items-center justify-between">
          <div class="flex items-start gap-4">
            <div class="text-right">
              <h1 class="text-xl font-bold text-gray-900">داشبورد هزینه‌ها</h1>
              <p class="text-sm text-gray-600 mt-1">مدیریت و پیگیری هزینه‌های سازمانی</p>
            </div>
            <div class="flex items-end gap-2">
              <button
                  style="max-width: 100px"
                  @click="refreshAll"
                  :disabled="loading"
                  class="flex items-center gap-2 px-4 py-2 rounded-lg bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                </svg>
                بروزرسانی
              </button>
            </div>

          </div>

          <div v-if="loading" class="flex items-center gap-2 text-sm text-gray-500">
            <svg class="w-4 h-4 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
            </svg>
            در حال بارگذاری...
          </div>
        </div>
      </div>
    </div>

    <div class=" mx-auto px-4  py-6">
      <div class="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <aside class="lg:col-span-3">
          <nav class="bg-white rounded-xl border border-gray-200 p-3 mb-6">
            <div class="space-y-2">
              <button
                  v-for="t in tabs"
                  :key="t.key"
                  @click="activeTab = t.key"
                  :class="[
                  'w-full text-right px-4 py-4 rounded-lg transition-all duration-200 border-2',
                  activeTab === t.key
                    ? 'bg-indigo-50 border-indigo-500 text-indigo-700 shadow-sm'
                    : 'bg-white border-gray-200 text-gray-700 hover:bg-gray-50'
                ]"
              >
                <div class="flex items-center justify-between">
                  <span class="font-semibold text-sm">{{ t.title }}</span>
                </div>
                <p class="text-xs mt-2 text-gray-500">{{ t.desc }}</p>
              </button>
            </div>
          </nav>

          <!-- Quick Stats -->
          <div class="bg-white rounded-xl border border-gray-200 p-4">
            <h3 class="font-semibold text-gray-900 text-sm mb-4">آمار سریع</h3>
            <div class="space-y-3">
              <div class="flex items-center justify-between p-3 bg-amber-50 rounded-lg border-r-4 border-amber-500">
                <span class="text-sm text-amber-700">هزینه امروز</span>
                <span class="text-sm font-semibold text-amber-900">{{ formatCurrency(stats.todayTotal) }}</span>
              </div>
              <div class="flex items-center justify-between p-3 bg-emerald-50 rounded-lg border-r-4 border-emerald-500">
                <span class="text-sm text-emerald-700">هزینه این ماه</span>
                <span class="text-sm font-semibold text-emerald-900">{{ formatCurrency(stats.monthTotal) }}</span>
              </div>
              <div class="flex items-center justify-between p-3 bg-violet-50 rounded-lg border-r-4 border-violet-500">
                <span class="text-sm text-violet-700">تعداد رکوردها</span>
                <span class="text-sm font-semibold text-violet-900">{{ stats.totalRecords }}</span>
              </div>
            </div>
          </div>
        </aside>

        <main class="col-span-9 space-y-6">
          <transition name="fade">
            <div v-if="notice"
                 class="rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-emerald-800 text-sm flex items-center gap-3">
              <svg class="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
              <span class="font-medium">{{ notice }}</span>
            </div>
          </transition>

          <section v-show="activeTab === 'create'" class="bg-white rounded-xl border border-gray-200">
            <div class="border-b border-gray-800 bg-gray-900 px-6 py-4 rounded-t-lg">
              <div class="flex items-center justify-between">
                <div>
                  <h2 class="text-lg font-semibold text-gray-50">ثبت هزینه جدید</h2>
                  <p class="text-sm text-gray-50 mt-1">اطلاعات هزینه را در فرم زیر وارد کنید</p>
                </div>
              </div>
            </div>

            <div class="p-2 bg-gray-200">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="space-y-6">
                  <h3 class="text-sm font-semibold text-blue-900 border-b border-gray-200 pb-2">اطلاعات پایه</h3>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">وضعیت *</label>
                    <select v-model="form.status"
                            class="w-full px-3 py-2 ring-1 ring-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-gray-50 text-sm">
                      <option value="APPROVED">فعال</option>
                      <option value="CANCELED">غیر فعال</option>
                    </select>
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">نوع هزینه *</label>
                    <select v-model="form.type"
                            class="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white">
                      <option value="PERSONNEL">حقوق پرسنل</option>
                      <option value="RENT">اجاره ماهانه</option>
                      <option value="EXTRA">مازاف (کارتن/چسب/...)</option>
                      <option value="SHIPPING">پست (واقعی پرداخت‌شده)</option>
                    </select>
                  </div>

                  <div v-if="form.type != 'PERSONNEL' && form.type != 'RENT'">
                    <div>
                      <label class="block text-sm font-medium text-gray-700 mb-2">تاریخ </label>
                      <input type="date" v-model="form.date_paid"
                             class="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"/>
                    </div>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">مبلغ *</label>
                    <input type="number" step="0.01" v-model.number="form.amount_gross"
                           class="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"
                           placeholder="0.00"/>
                  </div>
                </div>

                <div class="space-y-6">
                  <h3 class="text-sm font-semibold text-blue-900 border-b border-gray-200 pb-2">اطلاعات تکمیلی</h3>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">توضیح</label>
                    <textarea v-model="form.description"
                              class="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"
                              rows="3" placeholder="توضیح هزینه..."></textarea>
                  </div>

                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-2">مرجع/شماره سند</label>
                    <input type="text" v-model="form.reference_no"
                           class="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"
                           placeholder="مثلاً TRX-2025-1001"/>
                  </div>
                </div>

                <!-- Contextual Fields
                <div class="md:col-span-2 space-y-6">
                  <h3 class="text-sm font-semibold text-gray-900 border-b border-gray-200 pb-2">فیلدهای وابسته</h3>

                  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div v-if="form.type === 'RENT'" class="space-y-4">
                      <label class="block text-sm font-medium text-gray-700 mb-2">قرارداد اجاره</label>
                      <select v-model="form.rent_contract_id" class="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white">
                        <option :value="null">انتخاب کنید...</option>
                        <option v-for="r in rentContracts" :key="r.id" :value="r.id">{{ r.address || 'Contract' }} — {{ r.monthly_amount }} {{ r.currency }}</option>
                      </select>
                    </div>

                    <div v-if="form.type === 'PERSONNEL'" class="space-y-4">
                      <label class="block text-sm font-medium text-gray-700 mb-2">شناسه کاربر/کارمند</label>
                      <input type="text" v-model="form.employee" class="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" placeholder="user id" />
                    </div>

                    <div v-if="form.type === 'SHIPPING'" class="space-y-4">
                      <label class="block text-sm font-medium text-gray-700 mb-2">شماره مرسوله (meta)</label>
                      <input type="text" class="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" v-model="form.meta.tracking_no" placeholder="مثلاً RE123456789IR" />
                    </div>

                    <div class="space-y-4">
                      <label class="block text-sm font-medium text-gray-700 mb-2">تگ‌ها</label>
                      <div class="flex flex-wrap gap-2">
                        <label v-for="t in tags" :key="t.id"
                               :class="[
                                 'inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm cursor-pointer transition-all duration-200 border',
                                 form.tag_ids.includes(t.id)
                                   ? 'bg-indigo-100 text-indigo-700 border-indigo-300'
                                   : 'bg-gray-100 text-gray-600 border-gray-200 hover:bg-gray-200'
                               ]">
                          <input type="checkbox" class="hidden" :value="t.id" v-model="form.tag_ids" />
                          <span>#{{ t.name }}</span>
                        </label>
                      </div>
                    </div>

                    <div class="space-y-4">
                      <label class="block text-sm font-medium text-gray-700 mb-2">پیوست (اختیاری)</label>
                      <input type="file" multiple @change="onFiles" class="block w-full text-sm bg-white border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                      <p v-if="files.length" class="text-xs text-gray-500 mt-2 flex items-center gap-2">
                        <svg class="w-4 h-4 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        {{ files.length }} فایل انتخاب شد
                      </p>
                    </div>
                  </div>
                </div>
                  -->
              </div>

              <!-- Form Actions -->
              <div class="flex items-center justify-between mt-8 pt-6 border-t border-gray-200">
                <div class="flex items-center gap-3">
                  <button v-if="isEditing"
                          @click="cancelEdit"
                          class="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium">
                    لغو ویرایش
                  </button>

                  <button v-else
                          @click="resetForm"
                          class="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium">
                    پاک کردن فرم
                  </button>

                  <button
                      @click="isEditing ? updateExpense() : createExpense()"
                      :disabled="creating || !isFormValid"
                      class="px-4 py-2 bg-indigo-600 text-white items-center justify-center text-center rounded-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm font-medium"
                  >
                    <span v-if="creating" class="inline-flex items-center gap-2">
                      <svg class="w-4 h-4 animate-spin" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                      </svg>
                      در حال ذخیره...
                    </span>
                                    <span v-else>
                      {{ isEditing ? 'بروزرسانی هزینه' : 'ثبت هزینه' }}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </section>

          <section v-show="activeTab === 'list'" class="bg-white rounded-xl border border-gray-200">
            <div class="border-b border-gray-800 bg-gray-900 px-6 py-4 rounded-t-lg">
              <div class="flex items-center justify-between">
                <div>
                  <h2 class="text-lg font-semibold text-gray-50">
                    {{ isEditing ? 'ویرایش هزینه' : 'ثبت هزینه جدید' }}
                  </h2>
                  <p class="text-sm text-gray-50 mt-1">
                    {{ isEditing ? 'اطلاعات را اصلاح و ذخیره کنید' : 'اطلاعات هزینه را در فرم زیر وارد کنید' }}
                  </p></div>
              </div>
            </div>
            <div class="p-2">
              <div class="flex flex-wrap items-center gap-2">
                <div class="relative w-32">
                  <input
                      v-model="filters.search"
                      placeholder="جستجو ..."
                      class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-full text-right"
                      @keyup.enter="applyFilters"
                  >
                </div>
                <div>
                  <select
                      v-model="filters.type"
                      class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-right"
                      @change="applyFilters"
                  >
                    <option value="">همه نوع ها</option>
                    <option value="PERSONNEL">حقوق پرسنل</option>
                    <option value="RENT">اجاره ماهانه</option>
                    <option value="EXTRA">مازاف (کارتن/چسب/...)</option>
                    <option value="SHIPPING">پست (واقعی پرداخت‌شده)</option>
                  </select>
                </div>
                <div>
                  <select v-model="filters.status"
                          class="px-2 py-1.5 bg-gray-100 text-xs rounded-lg border w-32 text-right">
                    <option value="">همه وضعیت ها</option>
                    <option value="APPROVED">فعال</option>
                    <option value="CANCELED">غیر فعال</option>
                  </select>
                </div>
                <div class="flex gap-1">
                  <button
                      @click="clearFilters"
                      class="p-1.5 bg-gradient-to-r from-gray-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
                      title="حذف فیلترها"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                  </button>

                  <button
                      @click="applyFilters"
                      class="p-1.5 bg-gradient-to-r from-red-500 to-blue-600 text-white rounded-full shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-105"
                      title="اعمال فیلتر"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>

            <div class="p-6 border-b border-gray-200 bg-gray-50">
              <div class="grid grid-cols-2 gap-2">
                <div class="bg-white rounded-lg p-4 border border-gray-200">
                  <div class="text-sm text-gray-600 mb-2">تعداد</div>
                  <div class="text-md font-semibold text-gray-900">{{ expenses.length }}</div>
                </div>
                <div class="bg-white rounded-lg p-4 border border-gray-200">
                  <div class="text-sm text-gray-600 mb-2">مجموع این صفحه</div>
                  <div class="text-md font-semibold text-gray-900">{{ formatCurrency(pageTotal) }}</div>
                </div>
              </div>
            </div>

            <!-- Expenses Table -->
            <div class="overflow-auto">
              <table class="w-full text-sm">
                <thead class="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider bg-gray-50 whitespace-nowrap">
                    تاریخ
                  </th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider bg-gray-50 whitespace-nowrap">
                    نوع
                  </th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider bg-gray-50 whitespace-nowrap">
                    توضیح
                  </th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider bg-gray-50 whitespace-nowrap">
                    مبلغ
                  </th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider bg-gray-50 whitespace-nowrap">
                    وضعیت
                  </th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider bg-gray-50 whitespace-nowrap">
                    عملیات
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="e in expenses"
                    :key="e.id"
                    class="border-b border-gray-100 hover:bg-gray-50 transition-colors duration-150"
                >
                  <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                    <span class="font-medium">{{ e.date_paid }}</span>
                  </td>
                  <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                      <span :class="typeBadgeClass(e.type)">
                        {{ getTypeLabel(e.type) }}
                      </span>
                  </td>
                  <td class="text-center  whitespace-nowrap text-xs text-gray-900">
                    {{ e.description }}
                  </td>
                  <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                    <span class="font-semibold">{{ e.amount_gross | toMoney(0) }}</span>
                  </td>
                  <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                      <span :class="statusBadgeClass(e.status)">
                        {{ getStatusLabel(e.status) }}
                      </span>
                  </td>
                  <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                    <button
                        @click="onEdit(e)"
                        class="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg border text-xs hover:bg-gray-50"
                        title="ویرایش"
                    >
                      ✏️ ویرایش
                    </button>
                  </td>
                </tr>

                <!-- Empty State -->
                <tr v-if="!expenses.length && !loading">
                  <td colspan="8" class="px-4 py-8 text-center text-gray-500">
                    <svg class="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor"
                         viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                    </svg>
                    <p class="text-lg font-medium text-gray-400">هیچ هزینه‌ای یافت نشد</p>
                    <p class="text-sm text-gray-500 mt-2">برای شروع، هزینه جدیدی ثبت کنید</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div class="flex items-center justify-between p-6 border-t border-gray-200">
              <div class="text-sm text-gray-500">
                نمایش {{ expenses.length }} از {{ total }} رکورد
              </div>
              <div class="flex items-center gap-4">
                <select
                    v-model.number="itemsPerPage"
                    @change="goPage(1)"
                    class="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white text-sm"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>

                <div class="flex items-center gap-2">
                  <button
                      @click="goPage(currentPage - 1)"
                      :disabled="currentPage === 1"
                      class="px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm"
                  >
                    قبلی
                  </button>

                  <span class="px-4 text-sm text-gray-600">
                    صفحه {{ currentPage }} از {{ totalPages }}
                  </span>

                  <button
                      @click="goPage(currentPage + 1)"
                      :disabled="currentPage === totalPages"
                      class="px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-sm"
                  >
                    بعدی
                  </button>
                </div>
              </div>
            </div>
          </section>

          <section v-show="activeTab === 'reports'" class="bg-white rounded-xl border border-gray-200">
            <div class="border-b border-gray-200 bg-gray-50 px-6 py-4">
              <div class="flex items-center justify-between">
                <div>
                  <h2 class="text-lg font-semibold text-gray-900">گزارش‌گیری هزینه‌ها</h2>
                  <p class="text-sm text-gray-600 mt-1">تحلیل و آمار هزینه‌های سازمانی</p>
                </div>
                <button
                    @click="exportCSV"
                    class="flex items-center gap-2 px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors text-sm font-medium"
                >
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                  </svg>
                  خروجی CSV
                </button>
              </div>
            </div>

            <!-- Report Filters -->
            <div class="p-6 border-b border-gray-200">
              <div class="grid grid-cols-1 md:grid-cols-6 gap-4">
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">گروه‌بندی</label>
                  <select v-model="report.group_by"
                          class="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white">
                    <option value="month">ماه</option>
                    <option value="type">نوع</option>
                  </select>
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">از تاریخ</label>
                  <input type="date" v-model="report.date_from"
                         class="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"/>
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">تا تاریخ</label>
                  <input type="date" v-model="report.date_to"
                         class="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white"/>
                </div>
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-2">نوع</label>
                  <select v-model="report.type"
                          class="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white">
                    <option value="">همه</option>
                    <option value="APPROVED">فعال</option>
                    <option value="CANCELED">غیر فعال</option>
                  </select>
                </div>
                <div class="flex items-end">
                  <button
                      @click="fetchReport"
                      class="w-full px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors text-sm font-medium"
                  >
                    تولید گزارش
                  </button>
                </div>
              </div>
            </div>

            <!-- Report Summary -->
            <div class="p-6 border-b border-gray-200 bg-gray-50">
              <div class="grid grid-cols-3 gap-4">
                <div class="bg-white rounded-lg p-4 border border-gray-200">
                  <div class="text-sm text-gray-600 mb-2">جمع کل</div>
                  <div class="text-xl font-bold text-gray-900">{{ num(reportTotals.total) }} <span
                      class="text-xs">{{ reportCurrency }}</span></div>
                </div>
                <div class="bg-white rounded-lg p-4 border border-gray-200">
                  <div class="text-sm text-gray-600 mb-2">مالیات</div>
                  <div class="text-xl font-bold text-gray-900">{{ num(reportTotals.tax) }} <span
                      class="text-xs">{{ reportCurrency }}</span></div>
                </div>
                <div class="bg-white rounded-lg p-4 border border-gray-200">
                  <div class="text-sm text-gray-600 mb-2">خالص</div>
                  <div class="text-xl font-bold text-gray-900">{{ num(reportTotals.net) }} <span
                      class="text-xs">{{ reportCurrency }}</span></div>
                </div>
              </div>
            </div>

            <!-- Report Table -->
            <div class="overflow-auto">
              <table class="w-full text-sm">
                <thead class="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider bg-gray-50 whitespace-nowrap">
                    گروه
                  </th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider bg-gray-50 whitespace-nowrap">
                    ارز
                  </th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider bg-gray-50 whitespace-nowrap">
                    جمع مبلغ
                  </th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider bg-gray-50 whitespace-nowrap">
                    مالیات
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(r, i) in reportData" :key="i" class="border-b border-gray-100 hover:bg-gray-50">
                  <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                      <span class="font-medium">
                        <span v-if="report.group_by==='month'">{{ r.month }}</span>
                        <span v-else-if="report.group_by==='type'">{{ r.type }}</span>
                        <span v-else-if="report.group_by==='vendor'">{{ r['vendor__name'] || '—' }}</span>
                        <span v-else-if="report.group_by==='cost_center'">{{ r['cost_center__code'] || '—' }}</span>
                        <span v-else-if="report.group_by==='tag'">{{ r['tags__name'] || '—' }}</span>
                      </span>
                  </td>
                  <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900">
                      <span
                          class="inline-flex items-center px-2 py-1 rounded-full text-xs bg-gray-100 text-gray-700 font-medium">
                        {{ r.currency }}
                      </span>
                  </td>
                  <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-900 font-semibold">{{ num(r.total) }}</td>
                  <td class="px-4 py-3 whitespace-nowrap text-sm text-gray-600">{{ num(r.tax || 0) }}</td>
                </tr>
                <tr v-if="!reportData.length && !loading">
                  <td colspan="4" class="px-4 py-8 text-center text-gray-500">
                    <svg class="w-16 h-16 mx-auto text-gray-300 mb-4" fill="none" stroke="currentColor"
                         viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
                    </svg>
                    <p class="text-lg font-medium text-gray-400">گزارشی یافت نشد</p>
                    <p class="text-sm text-gray-500 mt-2">فیلترها را تنظیم و گزارش جدیدی تولید کنید</p>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </section>
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import DateField from "@/components/mcomponents/cleave/DateField";

export default {
  name: 'ExpensesDashboard',
  components: {DateField},
  data() {
    return {
      loading: false,
      creating: false,
      notice: '',
      editingId: null,
      activeTab: 'create',
      tabs: [
        {key: 'create', title: 'ثبت هزینه', desc: 'فرم سریع و ساده برای ثبت انواع هزینه', badge: null},
        {key: 'list', title: 'لیست هزینه‌ها', desc: 'جستجو، فیلتر و صفحه‌بندی', badge: 0},
        //{ key: 'reports', title: 'گزارش‌ها', desc: 'خلاصه‌های ماهانه و تحلیلی', badge: null }
      ],

      // Statistics
      stats: {
        todayTotal: 0,
        monthTotal: 0,
        totalRecords: 0
      },

      // Form state
      form: {
        type: 'PERSONNEL',
        status: 'APPROVED',
        date_incurred: '',
        date_paid: '',
        amount_gross: null,
        tax_amount: 0,
        currency: 'IRR',
        vendor_id: null,
        cost_center_id: null,
        rent_contract_id: null,
        employee: '',
        reference_no: '',
        description: '',
        meta: {},
        tag_ids: [],
      },
      files: [],

      // Dictionaries
      vendors: [],
      costCenters: [],
      tags: [],
      rentContracts: [],

      // List & filters
      itemsPerPage: 10,
      currentPage: 1,
      total: 0,
      expenses: [],
      filters: {
        date_from: '',
        date_to: '',
        type: '',
        status: '',
        search: '',
      },

      // Reports
      report: {
        group_by: 'month',
        date_from: '',
        date_to: '',
        currency: '',
        type: '',
      },
      reportData: [],
    }
  },
  computed: {
    isEditing() { return !!this.editingId },
    netAmount() {
      const g = Number(this.form.amount_gross || 0)
      const t = Number(this.form.tax_amount || 0)
      return this.num(g - t)
    },
    taxPercent() {
      const g = Number(this.form.amount_gross || 0)
      const t = Number(this.form.tax_amount || 0)
      if (!g) return 0
      return ((t / g) * 100).toFixed(1)
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.total / this.itemsPerPage))
    },
    isFormValid() {
      return this.form.type && this.form.date_incurred && this.form.amount_gross
    },
    summaryChips() {
      const sum = this.expenses.reduce((acc, e) => {
        acc.total += Number(e.amount_gross || 0)
        acc.tax += Number(e.tax_amount || 0)
        return acc
      }, {total: 0, tax: 0})
      return [
        {label: 'جمع صفحه', value: this.num(sum.total)},
        {label: 'مالیات صفحه', value: this.num(sum.tax)},
        {label: 'تعداد رکورد', value: this.expenses.length},
      ]
    },
    reportTotals() {
      const total = this.reportData.reduce((s, r) => s + Number(r.total || 0), 0)
      const tax = this.reportData.reduce((s, r) => s + Number(r.tax || 0), 0)
      return {total, tax, net: total - tax}
    },
    reportCurrency() {
      if (!this.reportData.length) return (this.report.currency || '').toUpperCase()
      return this.reportData[0].currency || (this.report.currency || '').toUpperCase()
    },
    pageTotal() {
      return this.expenses.reduce((sum, exp) => sum + (exp.amount_gross || 0), 0)
    },
    pageTax() {
      return this.expenses.reduce((sum, exp) => sum + (exp.tax_amount || 0), 0)
    }
  },
  mounted() {
    this.prefillDates()
    this.fetchDictionaries()
    this.fetchList()
    this.fetchStats()
  },
  methods: {
    async updateExpense() {
      if (!this.isEditing) return
      if (!this.form.type || !this.form.date_incurred || !this.form.amount_gross) {
        this.toast('نوع، تاریخ وقوع و مبلغ اجباری‌ست')
        return
      }
      this.creating = true
      try {
        const payload = this.cleanPayload({ ...this.form })
        const updated = await new Promise((resolve, reject) => {
          this.request({
            url: this.endpoint(`expenses/expenses/${this.editingId}/`),
            method: 'patch',
            data: payload,
            success: (data) => resolve(data),
            error: (e) => reject(e),
          })
        })

        this.toast('هزینه بروزرسانی شد')
        this.editingId = null
        this.resetForm()
        this.activeTab = 'list'
        await this.fetchList()
        await this.fetchStats()
      } catch (e) {
        console.error(e)
        this.toast('خطا در بروزرسانی هزینه')
      } finally {
        this.creating = false
      }
    },

    cancelEdit() {
      this.editingId = null
      this.resetForm()
      this.toast('ویرایش لغو شد')
    },
    async loadExpense(id) {
      try {
        const exp = await this.apiGet(`expenses/expenses/${id}/`)
        this.populateFormFromExpense(exp)
        this.editingId = id
        this.activeTab = 'create' // سوییچ به فرم
        this.toast('فرم با اطلاعات رکورد پر شد')
      } catch (e) {
        console.error('Error loading expense detail:', e)
        this.toast('خطا در دریافت جزئیات هزینه')
      }
    },
    onEdit(row) {
      this.loadExpense(row.id)
    },

    populateFormFromExpense(e) {
      this.form = {
        type: e.type || 'PERSONNEL',
        status: e.status || 'APPROVED',
        date_incurred: e.date_incurred || e.date_paid || new Date().toISOString().slice(0,10),
        date_paid: e.date_paid || '',
        amount_gross: e.amount_gross ?? null,
        tax_amount: e.tax_amount ?? 0,
        currency: e.currency || 'IRR',
        vendor_id: e.vendor?.id || null,
        employee: e.employee || '',
        reference_no: e.reference_no || '',
        description: e.description || '',
        meta: e.meta || {},
        tag_ids: (e.tags || []).map(t => t.id),
      }
    },
    num(n) {
      if (n === null || n === undefined || n === '') return '0'
      const x = Number(n)
      return x.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})
    },

    formatCurrency(amount) {
      if (!amount) return '۰'
      return new Intl.NumberFormat('fa-IR').format(amount) + ' تومان'
    },

    typeBadgeClass(type) {
      const base = 'inline-flex items-center px-3 py-1 rounded-full text-xs font-medium'
      const styles = {
        'PERSONNEL': `${base} bg-purple-100 text-purple-700 border border-purple-200`,
        'RENT': `${base} bg-amber-100 text-amber-700 border border-amber-200`,
        'EXTRA': `${base} bg-sky-100 text-sky-700 border border-sky-200`,
        'SHIPPING': `${base} bg-emerald-100 text-emerald-700 border border-emerald-200`
      }
      return styles[type] || base
    },

    statusBadgeClass(status) {
      const base = 'inline-flex items-center px-3 py-1 rounded-full text-xs font-medium'
      const styles = {
        'APPROVED': `${base} bg-blue-100 text-blue-700 border border-blue-200`,
        'CANCELED': `${base} bg-rose-100 text-rose-700 border border-rose-200`
      }
      return styles[status] || base
    },
    getTypeLabel(type) {
      const types = {
        'PERSONNEL': 'حقوق پرسنل',
        'RENT': 'اجاره ماهانه',
        'EXTRA': 'مازاف (کارتن/چسب/...)',
        'SHIPPING': 'پست'
      }
      return types[type] || type
    },

    getStatusLabel(status) {
      const statuses = {
        'DRAFT': 'پیش‌نویس',
        'APPROVED': 'فعال',
        'PAID': 'پرداخت شده',
        'CANCELED': 'غیر فعال'
      }
      return statuses[status] || status
    },

    toast(msg) {
      this.notice = msg
      setTimeout(() => this.notice = '', 3000)
    },

    prefillDates() {
      const today = new Date().toISOString().slice(0, 10)
      this.form.date_incurred = today
      this.report.date_from = new Date(new Date().getFullYear(), 0, 1).toISOString().slice(0, 10)
      this.report.date_to = today
    },

    onFiles(e) {
      this.files = Array.from(e.target.files || [])
    },

    fetchStats() {
      this.stats = {
        todayTotal: this.calculateTodayTotal(),
        monthTotal: this.calculateMonthTotal(),
        totalRecords: this.total
      }
    },

    calculateTodayTotal() {
      const today = new Date().toISOString().slice(0, 10)
      return this.expenses
          .filter(e => e.date_incurred === today)
          .reduce((sum, e) => sum + (e.amount_gross || 0), 0)
    },

    calculateMonthTotal() {
      const currentMonth = new Date().toISOString().slice(0, 7) // YYYY-MM
      return this.expenses
          .filter(e => e.date_incurred.startsWith(currentMonth))
          .reduce((sum, e) => sum + (e.amount_gross || 0), 0)
    },

    // Dictionaries
    async fetchDictionaries() {
      try {
        const [v, c, t, r] = await Promise.all([
          this.apiGet('expenses/vendors'),
          this.apiGet('expenses/cost-centers'),
          this.apiGet('expenses/tags'),
          this.apiGet('expenses/rent-contracts'),
        ])
        this.vendors = v.results || v
        this.costCenters = c.results || c
        this.tags = t.results || t
        this.rentContracts = r.results || r
      } catch (e) {
        console.error('Error fetching dictionaries:', e)
      }
    },

    // Create expense (+ optional attachments)
    async createExpense() {
      if (!this.form.type || !this.form.date_incurred || !this.form.amount_gross) {
        this.toast('نوع، تاریخ وقوع و مبلغ اجباری‌ست')
        return
      }
      this.creating = true
      try {
        const payload = this.cleanPayload({...this.form})
        const created = await this.apiPost('expenses/expenses/', payload)
        // Upload attachments if any
        if (this.files.length) {
          await Promise.all(this.files.map(f => this.uploadAttachment(created.id, f)))
        }
        this.toast('هزینه با موفقیت ثبت شد')
        this.resetForm()
        this.activeTab = 'list'
        this.fetchList()
        this.fetchStats()
      } catch (e) {
        console.error(e)
        this.toast('خطا در ثبت هزینه')
      } finally {
        this.creating = false
      }
    },

    resetForm() {
      this.form = {
        type: 'PERSONNEL', status: 'APPROVED', date_incurred: this.form.date_incurred,
        date_paid: '', amount_gross: null, tax_amount: 0, currency: 'IRR',
        vendor_id: null, cost_center_id: null, rent_contract_id: null, employee: '',
        reference_no: '', description: '', meta: {}, tag_ids: [],
      }
      this.files = []
    },

    cleanPayload(obj) {
      const copy = JSON.parse(JSON.stringify(obj))
      Object.keys(copy).forEach(k => {
        const v = copy[k]
        const emptyArray = Array.isArray(v) && v.length === 0
        const emptyObj = v && typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length === 0
        if (v === '' || v === null || v === undefined || emptyArray || emptyObj) {
          delete copy[k]
        }
      })
      return copy
    },

    async uploadAttachment(expenseId, file) {
      return new Promise((resolve, reject) => {
        const form = new FormData()
        form.append('expense', expenseId)
        form.append('file', file)
        form.append('filename', file.name)
        this.request({
          url: this.endpoint('expenses/attachments'),
          method: 'post',
          data: form,
          headers: {'Content-Type': 'multipart/form-data'},
          success: () => resolve(true),
          error: (e) => reject(e),
        })
      })
    },

    async fetchList() {
      console.log('testestestest')
      this.loading = true
      const params = {
        limit: this.itemsPerPage,
        offset: (this.currentPage - 1) * this.itemsPerPage,
        search: this.filters.search,
        type: this.filters.type,
        status: this.filters.status,
        date_from: this.filters.date_from,
        date_to: this.filters.date_to,
        ordering: '-date_incurred'
      }
      Object.keys(params).forEach(k => {
        if (params[k] === '' || params[k] === null) delete params[k]
      })
      try {
        const data = await this.apiGet('expenses/expenses', params)
        this.expenses = data || []
        this.total = data.count || this.expenses.length
        this.tabs = this.tabs.map(t => t.key === 'list' ? {...t, badge: this.total} : t)

        // Update stats if they weren't fetched from API
        if (this.stats.totalRecords === 0) {
          this.stats.totalRecords = this.total
        }
      } catch (e) {
        console.error('Error fetching expenses list:', e)
      } finally {
        this.loading = false
      }
    },

    applyFilters() {
      this.currentPage = 1
      this.fetchList()
    },

    clearFilters() {
      this.filters = {date_from: '', date_to: '', type: '', status: '', search: ''}
      this.applyFilters()
    },

    goPage(p) {
      this.currentPage = Math.max(1, Math.min(this.totalPages, p))
      this.fetchList()
    },

    // Reports
    async fetchReport() {
      const params = this.cleanParams({
        date_from: this.report.date_from,
        date_to: this.report.date_to,
        group_by: this.report.group_by,
        currency: this.report.currency,
        type: this.report.type,
      })
      try {
        const data = await this.apiGet('expenses/expenses/summary', params)
        this.reportData = data.results || []
        this.toast('گزارش آماده شد')
      } catch (e) {
        console.error('Error fetching report:', e)
        this.toast('خطا در دریافت گزارش')
      }
    },

    exportCSV() {
      if (!this.reportData.length) return
      const rows = [['group', 'currency', 'total', 'tax']]
      for (const r of this.reportData) {
        let g = ''
        if (this.report.group_by === 'month') g = r.month
        else if (this.report.group_by === 'type') g = r.type
        else if (this.report.group_by === 'vendor') g = r['vendor__name']
        else if (this.report.group_by === 'cost_center') g = r['cost_center__code']
        else if (this.report.group_by === 'tag') g = r['tags__name']
        rows.push([g, r.currency, r.total, r.tax || 0])
      }
      const csv = rows.map(r => r.map(x => '"' + (x !== undefined ? String(x).replace(/"/g, '""') : '') + '"').join(',')).join('\n')
      const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'})
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'expenses_report.csv'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    },

    // REST wrappers using project mixin
    apiGet(path, params) {
      return new Promise((resolve, reject) => {
        this.request({
          url: this.endpoint(path),
          method: 'get',
          params: this.cleanParams(params || {}),
          success: (data) => resolve(data),
          error: (e) => reject(e),
        })
      })
    },

    apiPost(path, data) {
      // remove empty strings like user mixin style
      const payload = this.cleanParams(data || {})
      return new Promise((resolve, reject) => {
        this.request({
          url: this.endpoint(path),
          method: 'post',
          data: payload,
          success: (data) => resolve(data),
          error: (e) => reject(e),
        })
      })
    },

    cleanParams(obj) {
      const copy = {...(obj || {})}
      Object.keys(copy).forEach(k => {
        if (copy[k] === '' || copy[k] === null || copy[k] === undefined) delete copy[k]
      })
      return copy
    },

    refreshAll() {
      if (this.activeTab === 'list') this.fetchList()
      if (this.activeTab === 'reports') this.fetchReport()
      if (this.activeTab === 'create') this.fetchDictionaries()
      this.fetchStats()
    },
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>